import {
  CreateCourseCategory,
  GetAllCourseCategorys,
  DeleteCourseCategory,
  UpdateCourseCategoryName,
  CreateCourseCategoryInput,
  CourseCategory,
  UpdateCourseCategoryNameInput,
  UpdateCourseCategoryState,
} from "../../PetKey/Main/Model/1_0_Initial/Backoffice/Training/Categories/PathItems";
import { Published } from "../../PetKey/Main/Model/1_0_Initial/Backoffice/Core/PathItems";
import { generateUUID, Result, TransportAbstractionBuilder, TransportContext } from "@peercolab/engine";
import { TranslationAppender } from "./translationMocks";
import { applyStateTransition, transitionState } from "../../../utils/GeneralHelpers";

export function mockCourseCategoryInterceptors(builder: TransportAbstractionBuilder, appender: TranslationAppender) {
  const dbCategories: CourseCategory[] = [];
  const dbCategoriesPublished: CourseCategory[] = [];

  const getCategory = (ctx: string | TransportContext): Result<CourseCategory> => {
    const id = typeof ctx === 'string' ? ctx : ctx.getPathParameter<string>('courseCategoryId');
    const category = dbCategories.find(c => c.id === id);
    if (!category) {
      return Result.notFound('Backoffice.CourseCategory.NotFound', `CourseCategory with id ${id} not found`);
    }
    return Result.ok(category);
  };

  const saveCategory = (result: Result<CourseCategory>, ctx: TransportContext): Result<CourseCategory> => {
    if (!result.success) {
      return result;
    }
    const category = result.value;
    const existingIndex = dbCategories.findIndex(c => c.id === category.id);
    if (existingIndex !== -1) {
      const existingPublishedIndex = dbCategoriesPublished.findIndex(c => c.id === category.id);
      dbCategories[existingIndex] = applyStateTransition(dbCategoriesPublished, existingPublishedIndex, result.meta, category, category.state, (item, newState) => {
        item.state = newState;
        return item;
      });
    } else {
      category.translationKey = appender('courseCategories', category.name);
      dbCategories.push(category);
    }
    return Result.ok(category);
  };

  return builder
    .intercept(new GetAllCourseCategorys().handle(async (input, ctx) => {
      return Result.ok(dbCategories);
    }))
    .intercept(new CreateCourseCategory().handle(async (input: CreateCourseCategoryInput, ctx) => {
      const newCategory: CourseCategory = {
        id: input.courseCategoryId ?? generateUUID(),
        name: input.name,
        translationKey: '',
        state: { state: 'draft' } as Published
      };
      return saveCategory(Result.ok(newCategory), ctx);
    }))
    .intercept(new DeleteCourseCategory().handle(async (input, ctx) => {
      const id = ctx.getPathParameter<string>('courseCategoryId');
      const idx = dbCategories.findIndex(c => c.id === id);
      if (idx === -1) {
        return Result.notFound('Backoffice.CourseCategory.NotFound', `CourseCategory with id ${id} not found`);
      }
      dbCategories.splice(idx, 1);
      return Result.ok(undefined);
    }))
    .intercept(new UpdateCourseCategoryName().handle(async (input: UpdateCourseCategoryNameInput, ctx) => {
      return saveCategory(getCategory(ctx)
        .maybe((value, meta) => {
          value.name = input.name;
          return Result.ok(value, meta);
        }), ctx)
        .convertToEmpty();
    }))
    .intercept(new UpdateCourseCategoryState().handle(async (input, ctx) => {
      return saveCategory(getCategory(ctx)
        .maybe((value, meta) => {
          value.state = transitionState(meta, value.state, input.stateTransition);
          return Result.ok(value, meta);
        }), ctx)
        .convertToEmpty();
    }))
}
